(function () {
  'use strict';

  if (window.__mallowMobileInteractionsLoaded) return;
  window.__mallowMobileInteractionsLoaded = true;

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function stickyBarFor(control) {
    return closest(control, '#sticky-atc-bar');
  }

  function stickyQuantity(bar) {
    var quantity = bar && bar.querySelector('#sab-qty-input');
    return Math.max(1, parseInt(quantity && quantity.textContent, 10) || 1);
  }

  function currentVariantId(button) {
    var mainButton = document.querySelector('.mp-atc-btn[data-variant-id], .mm-atc-btn[data-variant-id]');
    return parseInt(
      (mainButton && mainButton.getAttribute('data-variant-id')) || button.getAttribute('data-variant-id'),
      10
    );
  }

  function openCart() {
    var trigger = document.querySelector('.cart-pill-btn, [data-open-cart-drawer], .m-cart-icon-bubble');
    if (trigger) trigger.click();
  }

  function addFromStickyBar(button, bar) {
    var variantId = currentVariantId(button);
    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: stickyQuantity(bar) })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function (item) {
        button.classList.remove('is-loading');
        button.classList.add('is-success');
        document.dispatchEvent(new CustomEvent('mallow:cart-added', {
          bubbles: true,
          detail: { response: item, trigger: button }
        }));
        window.setTimeout(openCart, 100);
        window.setTimeout(function () {
          button.classList.remove('is-success');
          button.disabled = false;
        }, 1200);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
        window.alert('Something went wrong. Please try again.');
      });
  }

  function checkoutWithoutProtection(link) {
    if (document.body.classList.contains('cca-mixed-season-blocked')) {
      var notice = document.querySelector('[data-split-shipping-details]');
      if (notice) notice.click();
      return;
    }

    link.textContent = 'Preparing checkout...';
    link.setAttribute('aria-busy', 'true');

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          var handle = String(item.handle || '').toLowerCase();
          var properties = item.properties || {};
          if (handle === 'navidium-shipping-protection' || properties._mallow_safe === 'true') {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function () { window.location.assign('/checkout'); })
      .catch(function () { window.location.assign('/checkout'); });
  }

  document.addEventListener('click', function (event) {
    var quantityControl = closest(event.target, '#sab-qty-minus, #sab-qty-plus');
    if (quantityControl) {
      var quantityBar = stickyBarFor(quantityControl);
      var quantity = quantityBar && quantityBar.querySelector('#sab-qty-input');
      if (!quantity) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      quantity.textContent = quantityControl.id === 'sab-qty-plus'
        ? stickyQuantity(quantityBar) + 1
        : Math.max(1, stickyQuantity(quantityBar) - 1);
      return;
    }

    var addButton = closest(event.target, '#sab-atc-btn');
    if (addButton) {
      var addBar = stickyBarFor(addButton);
      if (!addBar) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addFromStickyBar(addButton, addBar);
      return;
    }

    var skipProtection = closest(event.target, '[data-skip-protection-checkout]');
    if (skipProtection) {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkoutWithoutProtection(skipProtection);
    }
  }, true);
})();
